module.exports = {
  purge: false,
  theme: {
    extend: {
      colors: {
        main: {
          100: '#EBEBEB',
          200: '#CCCCCC',
          300: '#ADADAD',
          400: '#707070',
          500: '#323232',
          600: '#2D2D2D',
          700: '#1E1E1E',
          800: '#171717',
          900: '#0F0F0F',
        },
        secondary: {
          100: '#E9F2F9',
          200: '#C8DEF0',
          300: '#A7C9E6',
          400: '#66A1D4',
          500: '#2479C1',
          600: '#206DAE',
          700: '#164974',
          800: '#103657',
          900: '#0B243A',
        },
        'footer-bg': '#F8F8F8',
        'footer-text': '#6e6e6e',
        'footer-social': '#adadad',
      },

      fontFamily: {
        'source-sans-pro': 'Source Sans Pro',
        gotham: 'Gotham Book',
        avenir: 'Avenir',
      },

      fontSize: {
        '5.5xl': '3.5rem',
        '7xl': '5rem',
        '8xl': '6rem',
        '8.5xl': '6.5rem',
        '9xl': '7rem',
        '9.5xl': '7.5rem',
        '10xl': '8rem',
      },

      maxWidth: {
        'screen-2xl': '1400px',
        'screen-3xl': '1600px',
        'screen-4xl': '1800px',
      },

      height: {
        28: '7rem',
        72: '18rem',
        80: '20rem',
        88: '22rem',
        96: '24rem',
      },

      width: {
        28: '7rem',
        72: '18rem',
        80: '20rem',
        88: '22rem',
        96: '24rem',
        104: '26rem',
        120: '30rem',
        196: '44rem',
      },
    },
  },
  variants: {},
  plugins: [],
}
